//Dependencias
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../const/routes';
import axiosInstance from '../../services/AxiosInstance';
import socket from '../../utils/socketClient';
import { useTranslation } from 'react-i18next';
//Componentes
import BannerFichas from '../../components/BannerFichas/BannerFichas';
import Navbar from '../../components/Navbar/Navbar';
import SessionBar from '../../components/SessionBar/SessionBar';
import Footer from '../../components/Footer/Footer';
//Funciones
import { fetchUserData } from '../../utils/api';

const EditarPerfil = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);

  const [formData, setFormData] = useState({
    email: '',
    nick_usuario: '',
    nombre_usuario: '',
    apellido_usuario: '',
    fecha_nacimiento: '',
    contrasenia: '',
    avatar: null,
  });

  const [isEditing, setIsEditing] = useState(false);
  const [currentField, setCurrentField] = useState('');
  const [currentValue, setCurrentValue] = useState('');

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const [isAvatarModalOpen, setIsAvatarModalOpen] = useState(false);

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  useEffect(() => {
    if (userData) {
      setFormData({
        nick_usuario: userData.nick_usuario || '',
        nombre_usuario: userData.nombre_usuario || '',
        apellido_usuario: userData.apellido_usuario || '',
        fecha_nacimiento: userData.fecha_nacimiento.split('T')[0] || '',
        contrasenia: '',
        email: userData.email || '',
        avatar: userData.avatar || null,
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    setFormData({
      ...formData,
      avatar: e.target.files[0],
    });
  };

  const handleEditClick = (field) => {
    setCurrentField(field);
    setCurrentValue(formData[field]);
    if (field === 'avatar') {
      setIsAvatarModalOpen(true);
    } else {
      setIsEditing(true);
    }
  };

  const LIMITE_POR_CAMPO = {
    nick_usuario: 15,
    nombre_usuario: 20,
    apellido_usuario: 20,
  };

  const handleEditChange = (e) => {
    const valor = e.target.value;
    const limite = LIMITE_POR_CAMPO[currentField];
    if (limite && valor.length > limite) return;
    setCurrentValue(valor);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    const formDataToSend = new FormData();
    formDataToSend.append(currentField, currentValue);
    if (currentField === 'avatar') {
      formDataToSend.append('avatar', formData.avatar);
    }

    try {
      const response = await axiosInstance.patch(
        '/api/usuario/updateUsuario',
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setFormData({
        ...formData,
        [currentField]: currentValue,
      });

      setIsEditing(false);
      setIsAvatarModalOpen(false);
      setSuccess(true);

      socket.emit('actualizacion-usuario', response.data);
    } catch (err) {
      if (err.response && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(' | ');
        setError(errorMessages);
      } else if (err.response && err.response.data.msg) {
        setError(err.response.data.msg);
      } else {
        setError(t('editProfile.errorMessage'));
      }
    }
  };

  const handleEditCancel = () => {
    setIsEditing(false);
    setIsAvatarModalOpen(false);
  };

  return (
    <div>
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 min-h-screen">
        <Navbar />
        {userData && <SessionBar />}
        <div className="flex flex-col flex-grow items-center justify-center text-center pb-10 mt-10 px-4">
          <div
            className={`p-6 lg:p-10 my-auto space-y-5 flex flex-col bg-bgContenedorOscuro rounded-lg w-full max-w-2xl
                      border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro
                      shadow-[0_0_30px_rgba(100,116,139,0.9)] transition-all duration-300 ease-in-out hover:shadow-[0_0_40px_rgba(100,116,139,1)]`}
          >
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {t('editProfile.title')}
            </h2>
            <p className="text-sm text-gray-300 mb-8">
              {t('editProfile.subtitle1')} <br />
              {t('editProfile.subtitle2')}
            </p>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.emailLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                  placeholder={t('editProfile.emailPlaceholder')}
                  disabled
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('email')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.nickLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="text"
                  name="nick_usuario"
                  value={formData.nick_usuario}
                  onChange={handleChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                  placeholder={t('editProfile.nickPlaceholder')}
                  disabled
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('nick_usuario')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.nameLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="text"
                  name="nombre_usuario"
                  value={formData.nombre_usuario}
                  onChange={handleChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                  placeholder={t('editProfile.namePlaceholder')}
                  disabled
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('nombre_usuario')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.lastNameLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="text"
                  name="apellido_usuario"
                  value={formData.apellido_usuario}
                  onChange={handleChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                  placeholder={t('editProfile.lastNamePlaceholder')}
                  disabled
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('apellido_usuario')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.birthdateLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="date"
                  name="fecha_nacimiento"
                  value={formData.fecha_nacimiento}
                  onChange={handleChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                  disabled
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('fecha_nacimiento')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.passwordLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="password"
                  name="contrasenia"
                  value={formData.contrasenia}
                  onChange={handleChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                  placeholder={t('editProfile.passwordPlaceholder')}
                  disabled
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('contrasenia')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-left text-gray-300 text-xs font-bold mb-2">
                {t('editProfile.avatarLabel')}
              </label>
              <div className="flex items-center">
                <input
                  type="file"
                  name="avatar"
                  onChange={handleImageChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600"
                />
                <button
                  className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={() => handleEditClick('avatar')}
                >
                  {t('editProfile.editButton')}
                </button>
              </div>
            </div>

            {success && (
              <p className="text-green-400 mt-4">
                {t('editProfile.successMessage')}
              </p>
            )}
            {error && <p className="text-red-400 mt-4">{error}</p>}

            <button
              onClick={() => navigate(ROUTES.perfil)}
              className="mt-6 text-blue-400 hover:underline text-lg"
            >
              {t('editProfile.backButton')}
            </button>
          </div>
        </div>
      </div>
      <Footer />

      {isEditing && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold mb-4">
              {t('editProfile.modalTitle', { field: currentField })}
            </h3>
            <form onSubmit={handleEditSubmit}>
              {currentField === 'avatar' ? (
                <input
                  type="file"
                  name={currentField}
                  onChange={handleImageChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600 mb-4"
                />
              ) : (
                <input
                  type="text"
                  name={currentField}
                  value={currentValue}
                  onChange={handleEditChange}
                  className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600 mb-4"
                />
              )}
              <div className="flex justify-end">
                <button
                  type="button"
                  className="mr-2 px-4 py-2 bg-gray-500 text-white rounded-lg"
                  onClick={handleEditCancel}
                >
                  {t('editProfile.cancelButton')}
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                >
                  {t('editProfile.saveButton')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {isAvatarModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold mb-4">
              {t('editProfile.avatarModalTitle')}
            </h3>
            <form onSubmit={handleEditSubmit}>
              <input
                type="file"
                name="avatar"
                onChange={handleImageChange}
                className="w-full px-4 py-2 text-sm text-gray-900 bg-gray-200 rounded-lg border-4 border-gray-300 focus:outline-none focus:border-indigo-600 mb-4"
              />
              <div className="flex justify-end">
                <button
                  type="button"
                  className="mr-2 px-4 py-2 bg-gray-500 text-white rounded-lg"
                  onClick={handleEditCancel}
                >
                  {t('editProfile.cancelButton')}
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                >
                  {t('editProfile.saveButton')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditarPerfil;
